import Image from 'next/image'
import Link from 'next/link'
import SEO from '../components/SEO'
import styles from '../styles/Automotive.module.css'
import language from '../languages/automotive.json'

import { features } from '../const/automotive'

export default function Automotive({locale}) {
    return (
        <div className={styles.container}>
        
            <SEO
                title={language["seo title"][locale]}
                description={language["seo desc"][locale]}
                image="https://inspektlabs.com/img/car.png"
                url="https://inspektlabs.com/automotive"
                page="automotive"
            />

            {/* Main Body */}
            <main className={styles.main}>

                {/* Featured Section */}
                <section className={styles.featured}>
                    <Image src="/img/automotive.svg" alt="Automotive" width={100} height={100} />
                    <h1 className={styles.featuredTitle}>{language["Digital Vehicle Inspections with AI"][locale]}</h1>
                    <p className={styles.featuredText}>Every automotive business depends on accurate vehicle condition checks but manual inspections are slow and inconsistent. Inspektlabs lets you detect damage instantly from photos or videos, so your team can assess vehicles in seconds with consistent, reliable results. See how the industry is adopting this in our guide to <a className={styles.showClick} target='_blank' href="https://inspektlabs.com/blog/ai-adoption-in-vehicle-inspections/">AI adoption in vehicle inspections</a>.</p>
                </section>

                {/* Features Section */}
                <section className={styles.features}>
                    
                    <h2 className={styles.featuresTitle}>{language["We focus on 6 major automotive aftermarket use-cases"][locale]}</h2>

                    <div className={styles.featuresContainer}>
                        { features.map(feature => (
                            <div className={styles.feature} key={feature.title[locale]}>
                                <div><Image src={`/img/${feature.img}`} alt={feature.title[locale]} width={100} height={100} /></div>
                                <h3>{feature.title[locale]}</h3>
                                <p>{ feature.text[locale] }</p>
                            </div>
                        )) }
                    </div>

                    <h2 className={styles.featuresTitle}>{language["systems"][locale]}</h2>
                    <p className={styles.featuresText}>{language["Both types of inspection systems are linked to our damage detection APIs"][locale]}</p>

                    <div className={styles.secondaryFeaturesContainer}>
                        <div className={styles.secondaryFeature}>
                            <div><Image src={'/img/smartphone-based.svg'} alt="Smartphone Based" width={100} height={100} /></div>
                            <div>
                                <h3>{language["Smartphone Based"][locale]}</h3>
                                <p>{language["Capture a 360° video"][locale]}</p>
                            </div>
                        </div>
                        <div className={styles.secondaryFeature}>
                            <div><Image src={'/img/fixed-installation.svg'} alt="Fixed Installation" width={100} height={100} /></div>
                            <div>
                                <h3>{language["Fixed Installation"][locale]}</h3>
                                <p>{language["Capture videos/photos of the vehicle using fixed camera"][locale]}</p>
                            </div>
                        </div>
                    </div>
                </section>
                

                {/* Case Studies */}
                <section className={styles.caseSection}>
                    <h2 className={styles.caseSectionTitle}>{language["Case Studies On AI Review"][locale]}</h2>
                    
                    <div className={styles.caseContainer}>
                        <div className={styles.case}>
                            <h3>Holiday Cars partners with Inspektlabs to secure Customers with the power of AI</h3>
                            <p>Holiday Cars, one of the most trusted Car Rental Aggregators, has partnered with Inspektlabs to empower customers with a solution to track and report pre-existing damage on vehicles they’re renting using the power of AI and computer vision.</p>
                            <Link href="/case-studies/caseStudy2" target="_blank" rel="noreferrer"><a className={styles.caseAction}>{language["Read More"][locale]}</a></Link>
                        </div>
                        <div className={styles.case}>
                            <h3>How AutoParts Group automates vehicle inspections using Inspektlabs AI</h3>
                            <p>AutoParts Group, Australia’s leading supplier of automotive collision parts, partnered with Inspektlabs to help automate their vehicle inspection process using Artificial Intelligence and computer vision, resulting in a reduction of inspection time from days to a few minutes.</p>
                            <Link href="/case-studies/caseStudy3" target="_blank" rel="noreferrer"><a className={styles.caseAction}>{language["Read More"][locale]}</a></Link>
                        </div>
                    </div>
                </section>

            </main>
        </div>
    )
}